import { AgeRange } from './AgeRange';

export class ParticipantUserSettings implements IParticipantUserSettings {
    ageRanges?: AgeRange[] | undefined;

    constructor(data?: IParticipantUserSettings) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['ageRanges'])) {
                this.ageRanges = [] as any;
                for (const item of _data['ageRanges'])
                    this.ageRanges!.push(AgeRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParticipantUserSettings {
        data = typeof data === 'object' ? data : {};
        const result = new ParticipantUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ageRanges)) {
            data['ageRanges'] = [];
            for (const item of this.ageRanges)
                data['ageRanges'].push(item.toJSON());
        }
        return data;
    }
}

export interface IParticipantUserSettings {
    ageRanges?: AgeRange[] | undefined;
}